import React from 'react'
import { isSaficDomain, isSjDomain } from 'utils/domain'

import SaficBackGroundGradient from './SaficBackGroundGradient'
import SjBackground from './SjBackground'

/**
 * メイン画面の背景
 */
const BackGroundGradient: React.FC<BackGroundGradientProps> = (props) => {
  return (
    <React.Fragment>
      {isSaficDomain() && <SaficBackGroundGradient {...props} />}
      {isSjDomain() && <SjBackground {...props} />}
    </React.Fragment>
  )
}

export type BackGroundGradientProps = {
  children?: React.ReactNode
  background?: string
}

export default BackGroundGradient
